module.exports = __webpack_public_path__ + "static/img/iconfont.490d659.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1560845219567
// module id = VuFK
// module chunks = 61